import * as ProgressPrimitive from "@radix-ui/react-progress";
import { cn } from "cn";
import type * as React from "react";

function Progress({
  className,
  value,
  ...props
}: React.ComponentProps<typeof ProgressPrimitive.Root>) {
  return (
    <ProgressPrimitive.Root
      data-slot="progress"
      className={cn(
        /* sorted */
        "relative overflow-hidden",
        "h-1.5 w-full",
        "bg-bg-light-low rounded-full",
        className,
      )}
      {...props}
    >
      <ProgressPrimitive.Indicator
        data-slot="progress-indicator"
        className="bg-stroke-light h-full w-full flex-1 transition-all"
        style={{ transform: `translateX(-${101 - (value || 0)}%)` }}
      />
    </ProgressPrimitive.Root>
  );
}

export { Progress };
